/**
 * Builds the canonical public URL for a vendor/breeder storefront.
 * Prefers the kebab-case `store_slug` when present (pretty URLs); falls
 * back to the UUID `id` for legacy data. The vendor lookup endpoint
 * accepts both, so callers can mix freely without breaking existing links.
 */
export function breederUrl(vendor) {
  if (!vendor) return "/breeders";
  return `/breeder/${vendor.store_slug || vendor.id}`;
}

/** Same as breederUrl but used when only the slug-or-id string is available. */
export function breederUrlFromKey(key) {
  return key ? `/breeder/${key}` : "/breeders";
}
